import React from 'react';
import { compose, graphql, withApollo } from 'react-apollo';
import {
  getItemById,
  updateItem,
  addItemValidity,
  removeItemValidity,
  getCategoryByItemId,
} from '../schema/shop-schema.graphql';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/icons/List';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import Typography from '@material-ui/core/Typography';
import localization from '../../../i18n/localization';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import FormControl from '@material-ui/core/FormControl';
import ItemValidityTable from './ItemValidityTable';
import Button from 'components/CustomButtons/Button.jsx';
import Clearfix from 'components/Clearfix/Clearfix.jsx';
import { DatePicker } from 'material-ui-pickers';
import { withSnackbar } from '../../snackbar/SnackbarContext';
import InputLabel from '@material-ui/core/InputLabel';
import Switch from '@material-ui/core/Switch';
import moment from 'moment-timezone';
import { TIME_ZONE } from '../../../i18n/config';

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
  separator: {
    height: '40px',
    borderBottom: '1px solid gray',
    marginBottom: '30px',
  },
  marginBottom20: {
    marginBottom: '20px',
  },
  icon: {
    marginRigth: '50px',
  },
});

class Item extends React.Component {
  state = {
    page: 0,
    rowsPerPage: 50,
    item: {
      enabled: false,
      validities: [],
    },
    newItemValidity: {
      startDate: null,
      endDate: null,
      selectableStartDate: null,
      selectableEndDate: null,
      title: '',
    },
  };

  onStartDateChange = date => {
    this.setState(prevState => ({
      ...prevState,
      newItemValidity: {
        ...prevState.newItemValidity,
        startDate: date,
        endDate: !prevState.newItemValidity.endDate
          ? date
          : prevState.newItemValidity.endDate,
        selectableStartDate: !prevState.newItemValidity.selectableStartDate
          ? date
          : prevState.newItemValidity.selectableStartDate,
        selectableEndDate: !prevState.newItemValidity.selectableEndDate
          ? date
          : prevState.newItemValidity.selectableEndDate,
      },
    }));
  };

  onEndDateChange = date => {
    this.setState(prevState => ({
      ...prevState,
      newItemValidity: {
        ...prevState.newItemValidity,
        endDate: date,
      },
    }));
  };

  onSelectableStartDateChange = date => {
    this.setState(prevState => ({
      ...prevState,
      newItemValidity: {
        ...prevState.newItemValidity,
        selectableStartDate: date,
      },
    }));
  };

  onSelectableEndDateChange = date => {
    this.setState(prevState => ({
      ...prevState,
      newItemValidity: {
        ...prevState.newItemValidity,
        selectableEndDate: date,
      },
    }));
  };

  validateInputs = () => {
    const { newItemValidity } = this.state;

    return (
      newItemValidity.title &&
      newItemValidity.startDate &&
      newItemValidity.selectableStartDate &&
      newItemValidity.selectableEndDate &&
      moment(newItemValidity.startDate).diff(
        newItemValidity.selectableStartDate,
        'days'
      ) <= 0 &&
      moment(newItemValidity.startDate).diff(
        newItemValidity.selectableEndDate,
        'days'
      ) <= 0 &&
      moment(newItemValidity.endDate).diff(
        newItemValidity.selectableStartDate,
        'days'
      ) >= 0 &&
      moment(newItemValidity.endDate).diff(
        newItemValidity.selectableEndDate,
        'days'
      ) >= 0
    );
  };

  addItemValidity = async () => {
    const { addNotification, addItemValidity } = this.props;
    try {
      const { newItemValidity, item } = this.state;

      if (!this.validateInputs()) {
        addNotification(
          'warning',
          localization.de.shop.itemValidityTable
            .WARNING_TITLE_STARTDATE_MISSING_FIELD
        );
        return;
      }

      const itemValidity = {
        itemId: item.id,
        title: newItemValidity.title,
        startDate: moment(newItemValidity.startDate)
          .startOf('day')
          .toISOString(),
        endDate: moment(newItemValidity.endDate)
          .endOf('day')
          .toISOString(),
        selectableStartDate: moment(newItemValidity.selectableStartDate)
          .startOf('day')
          .toISOString(),
        selectableEndDate: moment(newItemValidity.selectableEndDate)
          .endOf('day')
          .toISOString(),
      };
      console.log(itemValidity);
      const { data } = await addItemValidity({
        variables: { itemValidity },
      });

      if (!data.item) {
        addNotification('danger', 'Unerwarteter Fehler aufgetreten');
        return;
      }

      this.setState(prevState => ({
        ...prevState,
        item: data.item,
        newItemValidity: {
          title: '',
          startDate: null,
          endDate: null,
          selectableStartDate: null,
          selectableEndDate: null,
        },
      }));
      addNotification('success', localization.de.shop.OPERATION_SUCCESS);
    } catch (e) {
      addNotification('danger', 'Unerwarteter Fehler aufgetreten');
    }
  };

  deleteItemValidity = async entry => {
    const { addNotification, client } = this.props;
    try {
      const response = await client.query({
        query: removeItemValidity,
        variables: {
          id: entry.id,
        },
      });

      if (!response.data.itemValidity) {
        addNotification('danger', 'Unerwarteter Fehler aufgetreten');
        return;
      }

      await this.getItemWithItemRelations();
      addNotification('success', localization.de.shop.OPERATION_SUCCESS);
    } catch (e) {
      addNotification('danger', 'Unerwarteter Fehler aufgetreten');
    }
  };

  updateItem = async () => {
    const { updateItem, addNotification } = this.props;
    const { item } = this.state;

    try {
      const { data } = await updateItem({
        variables: {
          item: {
            id: item.id,
            enabled: item.enabled,
          },
        },
      });

      this.setState(prevState => ({
        ...prevState,
        item: data.item,
      }));

      addNotification('success', localization.de.shop.OPERATION_SUCCESS);
    } catch (e) {
      addNotification('danger', 'Unerwarteter Fehler aufgetreten');
      this.getItemWithItemRelations();
    }
  };

  changeEnabled = () => {
    this.setState(prevState => ({
      ...prevState,
      item: {
        ...prevState.item,
        enabled: !prevState.item.enabled,
      },
    }));
  };

  changeTitle = event => {
    const value = event.target.value;
    this.setState(prevState => ({
      ...prevState,
      newItemValidity: {
        ...prevState.newItemValidity,
        title: value,
      },
    }));
  };

  changePosition = event => {
    const value = event.target.value;
    this.setState(prevState => ({
      ...prevState,
      item: {
        ...prevState.item,
        position: value,
      },
    }));
  };

  getItemWithItemRelations = async () => {
    const { client, match } = this.props;

    const { data } = await client.query({
      fetchPolicy: 'network-only',
      query: getItemById,
      variables: {
        id: match.params.id,
      },
    });

    this.setState(prevState => ({
      ...prevState,
      item: data.item,
    }));
  };

  goToParentCategory = async () => {
    const { client, match, history } = this.props;

    const { data } = await client.query({
      query: getCategoryByItemId,
      variables: {
        id: match.params.id,
      },
    });

    history.push(`/shop/category/${data.category.id}`);
  };

  componentDidMount() {
    this.getItemWithItemRelations();
  }

  render() {
    const { classes } = this.props;
    const { item, newItemValidity } = this.state;

    return (
      <div className={classes.root}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="info">
              <List />
            </CardIcon>
            <div
              style={{
                marginTop: 60,
                marginBottom: 25,
                display: 'flex',
                width: '100%',
                alignItems: 'flex-start',
              }}
            >
              <div
                style={{
                  flex: 1,
                  display: 'flex',
                }}
              >
                <Typography variant="headline" color="textSecondary">
                  {localization.de.shop.ITEM}
                </Typography>
              </div>
            </div>
          </CardHeader>
          <CardBody>
            <React.Fragment>
              <GridContainer>
                <GridItem xs={12} sm={6} md={4} lg={4}>
                  <FormControl fullWidth={true}>
                    <InputLabel
                      htmlFor={localization.de.shop.itemTable.ID}
                      className={classes.inputLabel}
                    >
                      {localization.de.shop.itemTable.ID}
                    </InputLabel>
                  </FormControl>
                  <div />
                  <FormControl fullWidth={true}>
                    <CustomInput
                      inputProps={{ value: item.id, disabled: true }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={6} md={4} lg={4}>
                  <FormControl fullWidth={true}>
                    <InputLabel
                      htmlFor={localization.de.shop.itemTable.TYPE}
                      className={classes.inputLabel}
                    >
                      {localization.de.shop.itemTable.TYPE}
                    </InputLabel>
                  </FormControl>
                  <div />
                  <FormControl fullWidth={true}>
                    <CustomInput
                      inputProps={{
                        value: item.type,
                        disabled: true,
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={6} md={4} lg={4}>
                  <FormControl fullWidth={true}>
                    <InputLabel
                      htmlFor={localization.de.shop.itemTable.VENDOR}
                      className={classes.inputLabel}
                    >
                      {localization.de.shop.itemTable.VENDOR}
                    </InputLabel>
                  </FormControl>
                  <div />
                  <FormControl fullWidth={true}>
                    <CustomInput
                      inputProps={{ value: item.vendor, disabled: true }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </FormControl>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={6} md={6} lg={6}>
                  <FormControl fullWidth={true}>
                    <InputLabel
                      htmlFor={localization.de.shop.itemTable.POSITION}
                      className={classes.inputLabel}
                    >
                      {localization.de.shop.itemTable.POSITION}
                    </InputLabel>
                  </FormControl>
                  <div />
                  <FormControl fullWidth={true}>
                    <CustomInput
                      inputProps={{
                        value: item.position,
                        onChange: this.changePosition,
                        disabled: true,
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={6} md={6} lg={6}>
                  <FormControl fullWidth={true}>
                    <InputLabel
                      htmlFor={localization.de.shop.itemTable.ENABLED}
                      className={classes.label}
                    >
                      {localization.de.shop.itemTable.ENABLED}
                    </InputLabel>
                  </FormControl>
                  <div style={{ marginTop: 20 }} />
                  <FormControl fullWidth={true}>
                    <Switch
                      disabled={item.disableToggleEnabled}
                      onChange={this.changeEnabled}
                      checked={item.enabled}
                      color={'primary'}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <Button
                    style={{ marginTop: 40 }}
                    color="info"
                    onClick={this.updateItem}
                  >
                    {localization.de.shop.SAVE}
                  </Button>
                  <Clearfix />
                </GridItem>
              </GridContainer>
              <div className={classes.separator} />
              <GridContainer>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <Typography variant="subtitle1" color="textSecondary">
                    {localization.de.shop.NEW_ITEMVALIDITY}
                  </Typography>
                </GridItem>
                <GridItem xs={12} sm={6} md={4} lg={4}>
                  <FormControl fullWidth={true}>
                    <InputLabel
                      htmlFor={localization.de.shop.itemValidityTable.TITLE}
                      className={classes.inputLabel}
                    >
                      {localization.de.shop.itemValidityTable.TITLE}
                    </InputLabel>
                  </FormControl>
                  <div />
                  <FormControl fullWidth={true}>
                    <CustomInput
                      inputProps={{
                        value: newItemValidity.title,
                        onChange: this.changeTitle,
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={6} md={4} lg={4}>
                  <div style={{ marginTop: 20 }}>
                    <DatePicker
                      cancelLabel={'Abbrechen'}
                      clearLabel={'L\u00d6schen'}
                      label={localization.de.shop.itemValidityTable.START_DATE}
                      variant="outlined"
                      value={newItemValidity.startDate}
                      onChange={this.onStartDateChange}
                      format={'DD.MM.YYYY'}
                      clearable
                      InputProps={{ style: { fontSize: 14 } }}
                      InputLabelProps={{ style: { fontSize: 14 } }}
                    />
                  </div>
                </GridItem>
                <GridItem xs={12} sm={6} md={4} lg={4}>
                  <div style={{ marginTop: 20 }}>
                    <DatePicker
                      minDate={newItemValidity.startDate}
                      cancelLabel={'Abbrechen'}
                      clearLabel={'L\u00d6schen'}
                      label={localization.de.shop.itemValidityTable.END_DATE}
                      variant="outlined"
                      value={newItemValidity.endDate}
                      onChange={this.onEndDateChange}
                      format={'DD.MM.YYYY'}
                      clearable
                      InputProps={{ style: { fontSize: 14 } }}
                      InputLabelProps={{ style: { fontSize: 14 } }}
                    />
                  </div>
                </GridItem>
                <GridItem xs={12} sm={6} md={4} lg={4} />
                <GridItem xs={12} sm={6} md={4} lg={4}>
                  <div style={{ marginTop: 20 }}>
                    <DatePicker
                      minDate={newItemValidity.startDate}
                      maxDate={newItemValidity.endDate}
                      cancelLabel={'Abbrechen'}
                      clearLabel={'L\u00d6schen'}
                      label={
                        localization.de.shop.itemValidityTable
                          .SELECTABLE_START_DATE
                      }
                      variant="outlined"
                      value={newItemValidity.selectableStartDate}
                      onChange={this.onSelectableStartDateChange}
                      format={'DD.MM.YYYY'}
                      clearable
                      InputProps={{ style: { fontSize: 14 } }}
                      InputLabelProps={{ style: { fontSize: 14 } }}
                    />
                  </div>
                </GridItem>
                <GridItem xs={12} sm={6} md={4} lg={4}>
                  <div style={{ marginTop: 20 }}>
                    <DatePicker
                      minDate={newItemValidity.startDate}
                      maxDate={newItemValidity.endDate}
                      cancelLabel={'Abbrechen'}
                      clearLabel={'L\u00d6schen'}
                      label={
                        localization.de.shop.itemValidityTable
                          .SELECTABLE_END_DATE
                      }
                      variant="outlined"
                      value={newItemValidity.selectableEndDate}
                      onChange={this.onSelectableEndDateChange}
                      format={'DD.MM.YYYY'}
                      clearable
                      InputProps={{ style: { fontSize: 14 } }}
                      InputLabelProps={{ style: { fontSize: 14 } }}
                    />
                  </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <Button
                    style={{ marginTop: 40 }}
                    color="info"
                    onClick={this.addItemValidity}
                  >
                    {localization.de.shop.ADD_ITEMVALIDITY}
                  </Button>
                </GridItem>
              </GridContainer>
              <div className={classes.marginBottom20} />
              <GridContainer>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <Typography variant="subtitle1" color="textSecondary">
                    {localization.de.shop.VALIDITIES}
                  </Typography>
                  <ItemValidityTable
                    itemValidities={item.validities.map(validity => {
                      return {
                        ...validity,
                        startDate: moment
                          .tz(moment(validity.startDate), 'Europe/Zurich')
                          .format('YYYY-MM-DD'),
                        selectableStartDate: moment
                          .tz(
                            moment(validity.selectableStartDate),
                            'Europe/Zurich'
                          )
                          .format('YYYY-MM-DD'),
                        selectableEndDate: moment
                          .tz(
                            moment(validity.selectableEndDate).startOf('day'),
                            'Europe/Zurich'
                          )
                          .format('YYYY-MM-DD'),
                        endDate: moment
                          .tz(
                            moment(validity.endDate).startOf('day'),
                            'Europe/Zurich'
                          )
                          .format('YYYY-MM-DD'),
                      };
                    })}
                    onRowDelete={this.deleteItemValidity}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <Button
                    style={{ marginTop: 40 }}
                    color="info"
                    onClick={this.goToParentCategory}
                  >
                    {localization.de.shop.BACK}
                  </Button>
                  <Clearfix />
                </GridItem>
              </GridContainer>
            </React.Fragment>
          </CardBody>
        </Card>
      </div>
    );
  }
}

Item.propTypes = {
  match: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const enhance = compose(
  graphql(addItemValidity, { name: 'addItemValidity' }),
  graphql(updateItem, { name: 'updateItem' }),
  withStyles(styles),
  withSnackbar,
  withApollo
);

export default enhance(Item);



// WEBPACK FOOTER //
// ./src/views/shop/components/Item.jsx